<template>
  <div>
    <div class="card">
      <h3 class="card-header">
        {{ $t("headerClassData") }}:
        <a href="#"
          ><i
            class="bi bi-info-circle"
            data-toggle="modal"
            data-target="#infoModal"
            data-title="classSysHeaderInfoTitle"
            data-body="classSysGeneralHeaderInfoBody"
            @click.prevent="showmodal"
          ></i
        ></a>
      </h3>
      <form id="formClassification" action="" @submit.prevent>
        <div class="card-body">
          <div
            v-for="(classSystem, docindex) in getDocumentClassification_model"
            :key="docindex"
          >
            <div class="card-text border rounded mt-2 border-dark">
              <div class="row mb-3">
                <label
                  name="ClassificationSystemLabel"
                  for="ClassificationSystem"
                  class="col-lg-3 col-form-label"
                  >{{ $t("ClassificationSystem") }}:*
                  <a href="#"
                    ><i
                      class="bi bi-info-circle"
                      data-toggle="modal"
                      data-target="#infoModal"
                      data-title="classSysInfoTitle"
                      data-body="classSysInfoBody"
                      @click.prevent="showmodal"
                    ></i></a
                ></label>

                <div class="col-lg-9" v-if="docindex==0">
                  <input
                    required
                    class="form-control"
                    :id="'ClassificationSystem' + docindex"
                    :disabled="true"
                    :value="
                      getDocumentClassificationClassificationSystem(docindex)
                    "
                    @input.prevent="
                      setClassification(docindex, $event.target.value)
                    "
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  />
                </div>
                <div class="col-lg-9" v-else>
                  <input
                    required
                    class="form-control"
                    :id="'ClassificationSystem' + docindex"
                    :value="
                      getDocumentClassificationClassificationSystem(docindex)
                    "
                    @input.prevent="
                      setClassification(docindex, $event.target.value)
                    "
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  />
                  </div>
              </div>
              <div class="row mb-3">
                <label for="ClassId" class="col-lg-3 col-form-label"
                  >{{ $t("classIdInfoTitle") }}:*
                  <a href="#"
                    ><i
                      class="bi bi-info-circle"
                      data-toggle="modal"
                      data-target="#infoModal"
                      data-title="classIdInfoTitle"
                      data-body="classIdInfoBody"
                      @click.prevent="showmodal"
                    ></i></a
                ></label>
                <div
                  class="col-lg-9"
                  v-if="docindex == 0"
                >
                  <select
                    required
                    list="datalistClassId"
                    class="form-select"
                    :id="'ClassId' + docindex"
                    placeholder="{{$t('search')}}"
                    :value="getDocumentClassificationClassId(docindex)"
                    @input.prevent="setClassId(docindex, $event.target.value)"
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  >
                    <option
                      v-for="item in getClassNamePerLanguage(docindex)"
                      :key="item"
                      :value="item.ClassId"
                    >
                      {{ item.ClassId }} - {{ item.classname }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-9" v-else>
                  <input
                    required
                    class="form-control"
                    :id="'ClassId' + docindex"
                    :value="getDocumentClassificationClassId(docindex)"
                    @input.prevent="setClassId(docindex, $event.target.value)"
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  />
                </div>
              </div>

              <div class="card">
                <div class="card-body">
                  <div
                    class="row mb-3"
                    v-for="(item, classindex) in getClassNameType_model(
                      docindex
                    )"
                    :key="item"
                  >
                    <label for="ClassName" class="col-xxl-3 col-form-label"
                      >{{ $t("classNameInfoTitle") }}:*
                      <a href="#"
                        ><i
                          class="bi bi-info-circle"
                          data-toggle="modal"
                          data-target="#infoModal"
                          data-title="classNameInfoTitle"
                          data-body="classNameInfoBody"
                          @click.prevent="showmodal"
                        ></i></a
                    ></label>
                    <div
                      class="col-xxl-4"
                      v-if="docindex == 0"
                    >
                      <select
                        required
                        list="classNameList"
                        class="form-select"
                        id="ClassName"
                        placeholder="{{$t('search')}}"
                        :disabled="getDisabled(docindex)"
                        :value="getClassNameTypeClassname(docindex, classindex)"
                        @input.prevent="
                          setClassName(
                            docindex,
                            classindex,
                            $event.target.value
                          )
                        "
                        @focusout="singleFault($event.target)"
                        @keydown.enter.prevent
                      >
                        <option
                          v-for="item in classNameIdProposals[docindex]"
                          :key="item"
                          :value="item.ClassName"
                        >
                          {{ item.ClassName }}
                        </option>
                      </select>
                    </div>

                    <div class="col-xxl-4" v-else>
                      <input
                        required
                        class="form-control"
                        id="ClassName"
                        :disabled="getDisabled(docindex)"
                        :value="getClassNameTypeClassname(docindex, classindex)"
                        @input.prevent="
                          setClassName(
                            docindex,
                            classindex,
                            $event.target.value
                          )
                        "
                        @focusout="singleFault($event.target)"
                        @keydown.enter.prevent
                      />
                    </div>

                    <label for="ClassLang" class="col-xxl-2 col-form-label"
                      >{{ $t("classLangInfoTitle") }}:*
                      <a href="#"
                        ><i
                          class="bi bi-info-circle"
                          data-toggle="modal"
                          data-target="#infoModal"
                          data-title="classLangInfoTitle"
                          data-body="classLangInfoBody"
                          @click.prevent="showmodal"
                        ></i></a
                    ></label>
                    <div class="col-xxl-3">
                      <select
                        required
                        class="form-select"
                        id="ClassLang"
                        :disabled="getDisabled(docindex)"
                        :value="getClassNameTypeLanguage(docindex, classindex)"
                        @input.prevent="
                          setClassLanguage(classindex, docindex, $event)
                        "
                        @focusout="singleFault($event.target)"
                        @keydown.enter.prevent
                      >
                        <option
                          v-for="item in getLanguage()"
                          :key="item[0]"
                          :value="item[0]"
                        >
                          {{ item[0] }} - {{ item[1] }}
                        </option>
                      </select>
                    </div>

                    <div
                      class="col xxl-1 mt-3 mt-xxl-0"
                      v-if="classindex >= 1 && docindex > 1"
                    >
                      <button
                        class="btn btn-outline-danger"
                        style="width: 3rem"
                        @click.prevent="
                          removeClassNameType(docindex, classindex)
                        "
                      >
                        <i class="bi-x-circle" style="font-size: 1rem"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col xxl-1 mt-3 mt-xxl-0" v-if="docindex >= 2">
                    <button
                      class="btn btn-outline-primary"
                      style="width: 3rem"
                      @click.prevent="addClassNameType(docindex)"
                    >
                      <i class="bi-plus-circle" style="font-size: 1rem"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-8 gy-2">
              <button
                class="btn btn-outline-primary"
                style="width: 6.5rem"
                @click.prevent="addClassSystem"
              >
                <i class="bi-plus-circle" style="font-size: 1.5rem"></i>
              </button>
            </div>
            <div
              class="col-lg-4 gy-2"
              v-if="getDocumentClassification_model.length > 1"
            >
              <button
                class="btn btn-outline-danger"
                style="width: 4rem"
                @click.prevent="removeClassSystem"
              >
                <i class="bi-x-circle" style="font-size: 1.5rem"></i>
              </button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-8 align-left mt-3">
              <go-back-util />
            </div>
            <div class="col-sm-4 align-right mt-3">
              <button
                class="btn btn-success bi-caret-right"
                @click.prevent="pushToRefObject"
              >
                {{ $t("next Step") }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <modal-utils />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoBackUtil from "../utils/GoBackUtil.vue";
import Fault from "../utils/Fault";
import LangCodes from "../utils/LangCodes";
import i18n from "@/i18n";
import ModalUtils from "../utils/ModalsUtils.vue";

export default {
  name: "ClassificationDataCom",
  data() {
    return {
      fault: "",
      classificationProposals: [
        {
          id: "",
          ClassificationSystem:
            "VDI2770:2018",
        },
      ],
      classIdProposals: [
        [
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "01-01",
            classname: "Identification",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "02-01",
            classname: "Technical specification",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "02-02",
            classname: "Drawings, Plans",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "02-03",
            classname: "Components",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "02-04",
            classname: "Certificates",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-01",
            classname: "Assembly, Disassembly",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-02",
            classname: "Operation",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-03",
            classname: "General Safety",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-04",
            classname: "Inspection, Maintenance",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-05",
            classname: "Repair",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "03-06",
            classname: "Spare parts",
            language: "en",
          },
          {
            id: "",
            ClassificationSystem: "VDI2770:2018",
            ClassId: "04-01",
            classname: "Contract documents",
            language: "en",
          },
        ],
      ],
      classNameIdProposals: [
        [
          {
            id: "",
            ClassId: "01-01",
            language: "en",
            ClassName: "Identification",
          },
          {
            id: "",
            ClassId: "02-01",
            language: "en",
            ClassName: "Technical specification",
          },
          {
            id: "",
            ClassId: "02-02",
            language: "en",
            ClassName: "Drawings, Plans",
          },
          {
            id: "",
            ClassId: "02-03",
            language: "en",
            ClassName: "Components",
          },
          {
            id: "",
            ClassId: "02-04",
            language: "en",
            ClassName: "Certificates",
          },
          {
            id: "",
            ClassId: "03-01",
            language: "en",
            ClassName: "Assembly, Disassembly",
          },
          {
            id: "",
            ClassId: "03-02",
            language: "en",
            ClassName: "Operation",
          },
          {
            id: "",
            ClassId: "03-03",
            language: "en",
            ClassName: "General Safety",
          },
          {
            id: "",
            ClassId: "03-04",
            language: "en",
            ClassName: "Inspection, Maintenance",
          },
          {
            id: "",
            ClassId: "03-05",
            language: "en",
            ClassName: "Repair",
          },
          {
            id: "",
            ClassId: "03-06",
            language: "en",
            ClassName: "Spare parts",
          },
          {
            id: "",
            ClassId: "04-01",
            language: "en",
            ClassName: "Contract documents",
          },
        ],
      ],
      relatedClassIdObject: [
        {
          id: "",
          fromClassId_id: "",
          toClassId_id: "",
          ClassId: "",
        },
      ],
    };
  },
  components: {
    GoBackUtil,
    ModalUtils,
  },
  computed: {
    ...mapGetters("Classification", [
      "getClassNameType_model",
      "getClassNameTypeLanguage",
      "getClassNameTypeClassname",
      "getDocumentClassification_model",
      "getDocumentClassificationClassificationSystem",
      "getDocumentClassificationClassId",
    ]),
    ...mapGetters([
      "getNextRound",
    ]),
    ...mapGetters("DocId", ["getDocumentId"]),
    getComputedLanguage() {
      return this.theClassLang;
    },
  },
  methods: {
    ...mapActions("Classification", [
      "setClassNameType",
      "setClassNameTypeLanguage",
      "setClassNameTypeClassname",
      "setDocumentClassification",
      "setDocumentClassificationClassificationSystem",
      "setDocumentClassificationClassId",
      "setDocumentClassificationClassNameId",
      "addDocumentClassification",
      "addClassNameType",
      "removeDocumentClassification",
      "removeClassNameType",
    ]),
    ...mapActions("ActSteps", [
      "setRefObject",
      "setRefObjObjId",
      "setRefObjOptData",
      "setRefObjParty",
      "setRefObjDesc",
      "setDocVersion",
      "setDocVersionParty",
      "setClassification"
    ]),
    showmodal() {
      $("#infoModal").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget); // Button triggering the modal
        var title = button.data("title");
        var body = button.data("body");
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        modal.find(".modal-body").text(i18n.global.t(body));
      });
    },
    singleFault(ele) {
      return Fault.singleFault(ele);
    },
    getLanguage() {
      return LangCodes.getLang();
    },

    onFocusClassId(index) {
      let classsystem =
        this.getDocumentClassificationClassificationSystem(index);
      this.getClassIds(classsystem, index);
    },

    getClassNamePerLanguage(docindex) {
      if (this.classIdProposals[docindex]) {
        var classNamePerLanguage = this.classIdProposals[docindex].filter(
          (a) => a.language == this.$i18n.locale.substring(0, 2)
        );
        if (!classNamePerLanguage || classNamePerLanguage.length == 0) {
          classNamePerLanguage = this.classIdProposals[docindex];
        }
        return classNamePerLanguage;
      } else return [];
    },

    
    getDisabled(index) {
      if (
        index == 0
      ) {
        return true;
      } else return false;
    },

    pushToRefObject() {
      if (Fault.faultControl(document)) {
        this.setClassification(
          0,
          this.getDocumentClassificationClassificationSystem(0)
        );
        if (!this.getNextRound) {
          this.$router.push("/metadata/refobject/objectid");
        } else {
          this.$store.dispatch("ActSteps/setRefObject", true);
          this.$store.dispatch("ActSteps/setRefObjOptData", true);
          this.$store.dispatch("ActSteps/setRefObjParty", true);
          this.$store.dispatch("ActSteps/setRefObjDesc", true);
          this.$store.dispatch("ActSteps/setDocVersionParty", true);
          this.$store.dispatch("ActSteps/setDocVersion", true);
          this.$router.push("/metadata/docversion/documentversionid/");
        }
        this.$store.dispatch("ActSteps/setRefObject", true);
        this.$store.dispatch("ActSteps/setRefObjObjId", true);
      } else alert(i18n.global.t("faultMandatory"));
    },

    getLanguages(docindex, classindex) {
      var defaultObj = { language: "" };
      // changed [docindex]
      defaultObj = this.classNameIdProposals[docindex].find(
        (a) =>
          a.ClassName == this.getClassNameTypeClassname(docindex, classindex)
      ) || { language: "" };
      return defaultObj;
    },

    addClassSystem() {
      this.$store.dispatch("Classification/addDocumentClassification");
    },
    removeClassSystem() {
      this.$store.dispatch("Classification/removeDocumentClassification");
    },
    addClassNameType(docindex) {
      this.$store.dispatch("Classification/addClassNameType", docindex);
    },
    removeClassNameType(docindex, classindex) {
      const payload = {
        docindex: docindex,
        classindex: classindex,
      };
      this.$store.dispatch("Classification/removeClassNameType", payload);
    },
    setClassification(index, event) {
      if (index >= 0) {
        let payload = {
          index: index,
          ClassificationSystem: event,
        };
        this.$store.dispatch(
          "Classification/setDocumentClassificationClassificationSystem",
          payload
        );
        // this.getClassIds(event, index);
      }
    },
    setClassId(index, e) {
      
        let payload = {
          index: index,
          ClassId: e,
        };
        this.$store.dispatch(
          "Classification/setDocumentClassificationClassId",
          payload
        );
        if (index == 0) {
            let theClassName = this.classNameIdProposals[index].find(
              (a) => a.ClassId == e
            );
            this.setClassName(index, 0, theClassName.ClassName);
            
      }
    },
    setClassName(docindex, classindex, value) {
      const payload = {
        docindex: docindex,
        classindex: classindex,
        classname: value,
      };
      this.$store.dispatch("Classification/setClassNameTypeClassname", payload);
      const classpayload = {
        docindex: docindex,
        classindex: classindex,
        language: "en" //this.getLanguages(docindex, classindex).language,
      };
      this.$store.dispatch(
        "Classification/setClassNameTypeLanguage",
        classpayload
      );
    },
    setClassLanguage(classindex, docindex, event) {
      const payload = {
        docindex: docindex,
        classindex: classindex,
        language: event.target.value,
      };
      this.$store.dispatch("Classification/setClassNameTypeLanguage", payload);
    },
  },

};
</script>

<style scoped>
.card-text {
  padding: 1em;
}
</style>
